export const buildPartialJsonPayload = <T extends object>(payload: T, keys: (keyof T)[]) => {
  return keys.reduce<Partial<T>>((acc, key) => {
    const value = payload[key];

    if (value !== undefined && value !== null && value !== '') {
      return {
        ...acc,
        [key]: value,
      };
    }

    return acc;
  }, {});
};

export const buildPartialFormDataPayload = <T extends object>(payload: T, keys: (keyof T)[]) => {
  const formData = new FormData();

  keys.forEach((key) => {
    const value = payload[key];

    if (value === undefined || value === null || value === '') {
      return;
    }

    formData.append(key as string, value as Blob | string);
  });

  return formData;
};
